/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// idSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState={
    selectedFilterUsers:{
        data:[],
        selectedArr:[], 
        unselectedArr:[],
        isCheckedUsersAll:true,
        searchVal:'',
        totalUsers:0
        
    }
    
}
const wellnessUserSlice = createSlice({
    name: 'selectedFilterUsers',
    initialState: initialState,
    reducers: {
     
        toggleRowSelection: (state, action) => {
            let column=action.payload[0]
            const dataItems=action?.payload[1]?.map(item=>item._id)
            const selectAllofSearchOrCompleteList = action?.payload[2]
            const complete_list_or_searched_list = action?.payload[3]
            const isChecked = action?.payload[4]
            if(isChecked){
                if((complete_list_or_searched_list==='complete_list'&&!selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&!selectAllofSearchOrCompleteList)){
                    state.selectedFilterUsers.unselectedArr.includes(column)?state.selectedFilterUsers.unselectedArr=state.selectedFilterUsers?.unselectedArr?.filter(item=>item!==column):''
                    state.selectedFilterUsers.selectedArr.push(column)
                }else if((complete_list_or_searched_list==='complete_list'&&selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&selectAllofSearchOrCompleteList)){
                    state.selectedFilterUsers.unselectedArr.includes(column)?state.selectedFilterUsers.unselectedArr=state.selectedFilterUsers.unselectedArr.filter(item=>item!==column):''
                    state.selectedFilterUsers.selectedArr.push(column)
                }
            }
            
            else{
                if((complete_list_or_searched_list==='complete_list'&&!selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&!selectAllofSearchOrCompleteList)){
                    state.selectedFilterUsers.selectedArr.includes(column)?state.selectedFilterUsers.selectedArr=state.selectedFilterUsers?.selectedArr?.filter(item=>item!==column):''
                    state.selectedFilterUsers.unselectedArr.push(column)
                }else if((complete_list_or_searched_list==='complete_list'&&selectAllofSearchOrCompleteList)||(complete_list_or_searched_list==='searched_list'&&selectAllofSearchOrCompleteList)){
                    state.selectedFilterUsers.selectedArr.includes(column)?state.selectedFilterUsers.selectedArr=state.selectedFilterUsers.selectedArr.filter(item=>item!==column):''
                    state.selectedFilterUsers.unselectedArr.push(column)
                }
                
            }
            if(complete_list_or_searched_list==='complete_list'){
                if(state.selectedFilterUsers.selectedArr.length===0&&state.selectedFilterUsers.unselectedArr.length===0||(state.selectedFilterUsers.selectedArr.length===state.selectedFilterUsers.totalUsers)){
                    state.selectedFilterUsers.isCheckedUsersAll=true
                }else{
                    state.selectedFilterUsers.isCheckedUsersAll=false
                }
            }else if(complete_list_or_searched_list==='searched_list'){
                if(((dataItems?.every(item=>state.selectedFilterUsers.selectedArr.includes(item)))&&(!dataItems.some(item=>state.selectedFilterUsers.unselectedArr.includes(item))))||(action.payload[5]===true&&(!dataItems.some(item=>state.selectedFilterUsers.unselectedArr.includes(item))))){
                    state.selectedFilterUsers.isCheckedUsersAll=true
                } else{
                    state.selectedFilterUsers.isCheckedUsersAll=false
                }
            }
            

        },
        selectAllUserRows:(state,action)=>{
            // if(action.payload[0]===false){
            //     state.selectedFilterUsers.selectedArr=state.selectedFilterUsers.selectedArr.filter(
            //         (element) => !action.payload[1]?.map((item)=>item?._id).includes(element)
            //     );
            //     state.selectedFilterUsers.isCheckedUsersAll=false
            // }
            // else{
            //     const newData = action.payload[1]?.map((item) => item?._id);

            //     // Filter out elements that already exist in state.selectedFilterUsers.selectedArr[index]
            //     const uniqueData = newData.filter((item) => !state.selectedFilterUsers.selectedArr.includes(item));
            //     // state.selectedFilterUsers.selectedArr[index].push(action.payload[1]?.data?.map((item)=>item?.user_id))
            //     state.selectedFilterUsers.selectedArr.push(...uniqueData)
            //     state.selectedFilterUsers.isCheckedUsersAll=true
            // }
            state.selectedFilterUsers.isCheckedUsersAll=action.payload[0]
            const dataItems= action.payload[1]?.map(item=>item._id)
            const searchedItem = action.payload[2]
            if(searchedItem?.trim()===''){
                state.selectedFilterUsers.selectedArr=[]
                state.selectedFilterUsers.unselectedArr=[]
            }else{
                if(action.payload[0]===false){
                    state.selectedFilterUsers.selectedArr?.length>0? state.selectedFilterUsers.selectedArr = state.selectedFilterUsers.selectedArr.filter(item=> !dataItems.includes(item)):''
                    let newArr= new Set([...state.selectedFilterUsers.unselectedArr, ...dataItems])
                    state.selectedFilterUsers.unselectedArr = [...newArr]
                }else if (action.payload[0]===true){
                    let newArr = new Set([...state.selectedFilterUsers.selectedArr, ...dataItems]);
                    state.selectedFilterUsers.selectedArr = [...newArr]
                    state.selectedFilterUsers.unselectedArr?.length>0? state.selectedFilterUsers.unselectedArr = state.selectedFilterUsers.unselectedArr.filter(item=> !dataItems.includes(item)):''
                }
                
            }
           
 
        },
     
        
        searchReducerr:(state,action)=>{
            // const allExistMethod1 = action?.payload[0]?.every((item2) =>
            //     state.selectedFilterUsers.selectedArr?.some((item1) => item1 === item2._id)
            // )
            // if(allExistMethod1){
            //     state.selectedFilterUsers.isCheckedUsersAll=true
            // }
            // else{
            //     state.selectedFilterUsers.isCheckedUsersAll=false
            // }
            const dataItems=action?.payload[0]?.map(item=>item._id)
            const selectAllofSearchOrCompleteList = action?.payload[1]
            const selectAllofSearch= action?.payload[2]
            const complete_list_or_searched_list = action?.payload[3]
            if(complete_list_or_searched_list==='complete_list'){
                if((selectAllofSearchOrCompleteList&&state.selectedFilterUsers.unselectedArr.length===0&&action.payload[4]!=='empty')||(state.selectedFilterUsers.selectedArr.length===state.selectedFilterUsers.totalUsers&&action.payload[4]!=='empty')){
                    state.selectedFilterUsers.isCheckedUsersAll=true
                }else{
                    state.selectedFilterUsers.isCheckedUsersAll=false
                }
            }else{
                if((dataItems.every(item => state.selectedFilterUsers.selectedArr.includes(item))||(selectAllofSearchOrCompleteList&&!(dataItems.some(item=>state.selectedFilterUsers.unselectedArr.includes(item)))))){
                    state.selectedFilterUsers.isCheckedUsersAll=true
    
                }else{
                    state.selectedFilterUsers.isCheckedUsersAll=false
                }
            }
           

            
        },
        handleTotalUsers:(state,action) => {
            state.selectedFilterUsers.totalUsers = action.payload[0]
        },
       
        resetOrgList:(state)=>{
            state.selectedFilterUsers.selectedArr=[], 
            state.selectedFilterUsers.isCheckedUsersAll=true,
            state.selectedFilterUsers.data=[],
            state.selectedFilterUsers.unselectedArr=[],
            state.selectedFilterUsers.searchVal='',
            state.selectedFilterUsers.totalUsers=0
   

        },
        handleFillFromSearchParamsUsers:(state,action) => {
            state.selectedFilterUsers.selectedArr= action.payload[0]
            state.selectedFilterUsers.unselectedArr=action.payload[1]
        },
        resetTempFilterUsersOpen:(state)=>{
            state.selectedFilterUsers.selectedArr=[], 
            state.selectedFilterUsers.isCheckedUsersAll=true,
            state.selectedFilterUsers.unselectedArr=[]
        },
        handleEmptyUsersDropdown:(state)=>{
            state.selectedFilterUsers.isCheckedUsersAll=false,
            state.selectedFilterUsers.selectedArr=[],
            state.selectedFilterUsers.unselectedArr=[]
        }
       

    }
});

export const { handleEmptyUsersDropdown,handleFillFromSearchParamsUsers,resetTempFilterUsersOpen,resetOrgList,searchReducerr,toggleRowSelection,selectAllUserRows,handleTotalUsers} = wellnessUserSlice.actions;
export default wellnessUserSlice.reducer;
